import { combineReducers } from "redux"
import { analytics } from './analyticsReducer'

const historyReducers = combineReducers({
    analytics,
})

export default historyReducers